import { EventEmitter, OnInit } from '@angular/core';
import { ChangeDetectionStrategy } from '@angular/core';
import { Component, Input, Output } from '@angular/core';

@Component({
    selector: 'rateer',
    templateUrl: './rateer.component.html',
    styleUrls: ['rateer.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class RateerComponent implements OnInit {
    
    @Input() rate: number;
    @Input() max: number;
    @Output() rateChange: EventEmitter<number> = new EventEmitter<number>();

    public numbers: number[];
    private hover: boolean = false;

    ngOnInit(): void {
        this.numbers = Array(this.max).fill(0).map((x,i)=>i + 1);
    }


    onSelectRate(value: number) {
        this.rate = value;
        this.rateChange.emit(this.rate);
    }
}